import { Grid } from '@mui/material';
import ProjectIssuesComponent from '../../components/project-dashboard/issues/ProjectIssuesComponent';
import DashboardLayout from '../../layout/dashboard/DashboardLayout';
import { useAccess } from '../../hooks/useAccess';

const ProjectIssuesPage = () => {
  const { canAccess } = useAccess();

  const isAdmin = canAccess('ViewProjectDashboard');

  return (
    <DashboardLayout>
      <Grid container spacing={2}>
        <Grid item md={12}>
          <ProjectIssuesComponent isAdmin={isAdmin} />
        </Grid>
      </Grid>
    </DashboardLayout>
  );
};

export default ProjectIssuesPage;
